/* eslint-disable indent */
import { ROUTES_PATH } from 'constants/routesPath'
import { useRecoverHook } from 'hooks/useRecoverHook'
import { useMemo, useState } from 'react'
import { UNICO_CONSTANTS } from 'redesign/constants'
import { useUnicoService } from 'services/unico'
import { Contact } from 'typings'
import { BiometyDataType } from 'typings/unico'
import { clearCpf } from 'utils'

type OriginType = 'otp' | 'recover' | 'cadastro' | undefined

export const useBiometry = (contacts: Array<Contact>) => {
    const [biometyData, setBiometyData] = useState<BiometyDataType>({
        federalTaxId: undefined,
        id: undefined,
        contacts: [],
    })
    const [isLoadingBiometry, setIsLoadingBiometry] = useState(false)
    const { createBiometryUrl, checkUpdateContactBiometryLimit } = useUnicoService()
    const recover = useRecoverHook()

    const biometyDataLS: BiometyDataType = JSON.parse(sessionStorage.getItem(UNICO_CONSTANTS.STORAGE)!)
    const personalData = JSON.parse(sessionStorage.getItem('@LiviaAuth:SignUpPersonalData')!)
    const userCpf = clearCpf(recover?.username || personalData?.cpf || biometyDataLS?.federalTaxId || '')

    const {
        location: { href: url, origin },
    } = window

    const fluxoAtual: OriginType = useMemo(
        () =>
            url.includes('otp') ? 'otp' : url.includes('recuperar-senha') ? 'recover' : url.includes('mdm') ? 'cadastro' : undefined,
        [url],
    )

    const urlCallBack = `${origin}${ROUTES_PATH.FACE_BIOMETRICS_SCREEN}`

    async function createBiometry() {
        setIsLoadingBiometry(true)
        try {
            const {
                createBiometryUrl: { id, userRedirectUrl },
            } = await createBiometryUrl(userCpf, urlCallBack)

            setBiometyData(prevState => ({
                ...prevState,
                id,
            }))

            const dadosAnteriores = biometyDataLS || biometyData
            const novosDados = { id, federalTaxId: userCpf, contacts, unico: true, userRedirectUrl }

            const dadosAtualizados = { ...dadosAnteriores, ...novosDados }
            sessionStorage.setItem(UNICO_CONSTANTS.STORAGE, JSON.stringify(dadosAtualizados))
            return userRedirectUrl
        } catch (error) {
            const erro = error?.graphQLErrors?.[0]
            console.error('Erro ao criar biometria facial', erro.extensions?.code, erro.message)
            setIsLoadingBiometry(false)
            return undefined
        }
    }

    async function checkBiometryLimit() {
        setIsLoadingBiometry(true)
        try {
            const {
                checkUpdateContactBiometryLimit: { status },
            } = await checkUpdateContactBiometryLimit(userCpf)
            return status
        } catch (error) {
            const erro = error?.graphQLErrors?.[0]
            console.error('Erro ao checar limite de biometria facial', erro?.extensions?.code, erro.message)
            return null
        } finally {
            setIsLoadingBiometry(false)
        }
    }

    return {
        fluxoAtual,
        isLoadingBiometry,
        createBiometry,
        checkBiometryLimit,
    }
}
